import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import Label from "../components/Label";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  CircularProgress
} from "@mui/material";
// components
import Page from "../components/Page";
// StateData
import { fetchallcountrylist, fetchallstatelist } from "src/utils/common";
import { UpdateStateStatus } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { InsertState } from "src/api/commonapi";
import { EditSharp } from "@mui/icons-material";
import { updateState } from "src/api/commonapi";
import Select from "react-select";
import { IsNotValue } from "src/constant/variable";
import CustomLoader from "src/components/CustomLoader";
// ----------------------------------------------------------------------

export default function State() {
  const [step, setStep] = useState(1);

  const [isLoading, setIsLoading] = useState(false);

  const [statelist, setstatelist] = useState([]);
  const [newstatelist, setnewstatelist] = useState([]);
  const [filterstate, setfilterstate] = useState("");
  const [getdata, setgetdata] = useState({ c_id: "", state_name: "" });
  const [countryList, setCountryList] = useState([]);
  const onChangeFunction = (e) => {
    setgetdata({
      ...getdata,
      [e.target.name]: e.target.value
    });
  };

  const getCountry = async () => {
    setCountryList(await fetchallcountrylist());
  };

  useEffect(async () => {
    getCountry();
  }, []);

  useEffect(() => {
    countryList?.forEach((country) => {
      if (country?.default == 1) setgetdata((prev) => ({ ...prev, c_id: country?.c_id }));
    });
  }, [countryList, statelist]);

  const handleSubmit = async (e) => {
    let resp = null;
    if (step == 1) {
      if (!IsNotValue.includes(getdata.state_name) && !IsNotValue.includes(getdata.c_id)) {
        setIsLoading(true);
        resp = await InsertState(JSON.stringify(getdata));
        setIsLoading(false);
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill Required Fields"
        });
        notify();
      }
    } else if (step == 2) {
      if (!IsNotValue.includes(getdata.state_name) && !IsNotValue.includes(getdata.c_id)) {
        setIsLoading(true);
        resp = await updateState(JSON.stringify(getdata));
        setIsLoading(false);
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill Required Fields"
        });
        notify();
      }
    }
    let notify = notification({
      type: resp?.status == 0 ? "error" : "success",
      message: resp?.message
    });
    if (!IsNotValue.includes(resp)) notify();
    if (resp?.status == 1) {
      getstatelist();
      setgetdata({ c_id: "", state_name: "" });
      if (step == 2) setStep(1);
    }
  };

  const changestatus = async (state_id, s_status) => {
    let fdata = new FormData();
    fdata.append("state_id", state_id);
    fdata.append("s_status", s_status);

    setIsLoading(true);

    const resp = await UpdateStateStatus(fdata);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) getstatelist();
  };

  const filterData = () => {
    let nstate = [];
    nstate =
      statelist &&
      statelist.filter((state) => {
        if (
          state.state_name.toLowerCase().includes(filterstate?.toLowerCase()) ||
          state.country_name.toLowerCase().includes(filterstate?.toLowerCase())
        ) {
          return state;
        }
      });
    setnewstatelist(nstate);
  };

  useEffect(async () => {
    if (filterstate != undefined) {
      await filterData();
    }
  }, [filterstate, statelist]);

  const getstatelist = async () => {
    setIsLoading(true);
    setstatelist(await fetchallstatelist());
    setIsLoading(false);
  };

  useEffect(async () => {
    getstatelist();
  }, []);

  const exportColumns = [
    { label: "No", key: "state_id" },
    { label: "State Name", key: "state_name" }
  ];
  const columns = [
    {
      name: "No",
      wrap: true,
      label: "No",
      key: "state_id",
      selector: (row) => row.state_id,
      sortable: true
    },
    {
      name: "State Name",
      wrap: true,
      label: "State Name",
      key: "state_name",
      selector: (row) => row.state_name,
      sortable: true
    },
    {
      name: "Country Name",
      wrap: true,
      label: "Country Name",
      key: "country_name",
      selector: (row) => row.country_name,
      sortable: true
    },
    {
      name: "Status",
      wrap: true,
      selector: (row) => (
        <>
          {row.s_status == 0 ? (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="success"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "16px"
                  }}
                >
                  Active
                </Label>

                <Button
                  variant="contained"
                  onClick={() => {
                    changestatus(row.state_id, 1);
                  }}
                  style={{ background: "#ff4842" }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Deactive
                </Button>
              </div>
            </>
          ) : (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="error"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "14px"
                  }}
                >
                  Deactive
                </Label>

                <Button
                  variant="contained"
                  onClick={() => {
                    changestatus(row.state_id, 0);
                  }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Active
                </Button>
              </div>
            </>
          )}
        </>
      )
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      cell: (row) => (
        <>
          <a
            onClick={async () => {
              setgetdata(row);
              setStep(2);
              // getCountry();

              window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
            }}
          >
            <Tooltip title="Edit Chapter">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </a>
        </>
      )
    }
  ];
  return (
    <Page title="State | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            State
          </Typography>
        </Stack>

        {/* Start Country Form */}
        <Card style={{ padding: "25px", marginBottom: "25px" }}>
          <Stack spacing={10} style={{ marginBottom: "15px" }}>
            <label style={{ marginBottom: "10px" }}>Select Country</label>

            <Select
              value={
                countryList != null &&
                countryList
                  .map((c) => {
                    if (c.c_id == getdata?.c_id) {
                      return { value: c.c_id, label: c.country_name };
                    }
                  })
                  .filter((n) => n)[0]
              }
              style={{ marginTop: "0px" }}
              name="country"
              onChange={(e) => {
                setgetdata((prev) => ({ ...prev, c_id: e?.value }));
              }}
              options={
                countryList != null &&
                countryList.map((chpt) => {
                  return { value: chpt.c_id, label: chpt.country_name };
                })
              }
            />
          </Stack>
          {/* {getdata == null ? "" : <label style={{ marginBottom: "15px" }}>Enter State Name</label>} */}
          <Stack spacing={3}>
            <TextField
              onChange={onChangeFunction}
              fullWidth
              value={getdata?.state_name}
              autoComplete="false"
              type="text"
              name="state_name"
              // label={getdata == null ? "Enter State Name" : ""}
              label={"Enter State Name"}
            />
          </Stack>
          <Button
            onClick={handleSubmit}
            style={{ marginTop: "15px" }}
            type="submit"
            variant="contained"
            disabled={isLoading}
            startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
          >
            {step == 1 ? "Add State" : step == 2 ? "Edit State" : ""}
          </Button>
        </Card>
        {/* End State Form */}
        <Card style={{ padding: "25px" }}>
          <Grid item xs={6}>
            <Stack spacing={3} style={{ marginBottom: "15px" }}>
              <TextField
                style={{ marginTop: "5px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Search State"
                placeholder="Search State"
                name="search"
                value={filterstate}
                onChange={(e) => {
                  setfilterstate(e.target.value);
                }}
              />
            </Stack>
          </Grid>
          {statelist && (
            <>
              <Button className="btn btn-export">
                <CSVLink
                  data={newstatelist}
                  headers={exportColumns}
                  filename={"State List.csv"}
                  className="btn btn-primary test"
                  target="_blank"
                >
                  Export CSV
                </CSVLink>
              </Button>
            </>
          )}
          <DataTable
            title="State List"
            filter
            pagination
            highlightOnHover
            columns={columns}
            data={newstatelist}
            progressPending={isLoading}
            progressComponent={<CustomLoader />}
          />
        </Card>
      </Container>
    </Page>
  );
}
